import { useQuery } from '@hooks/reactQuery';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { getProfileUserAsPo } from '@api/users';

import { extractQueryParams } from '@utils/common';
import { hideDefaultRole } from '@utils/users';

import { IId } from '@interfaces/common/common';
import { IUserProfilePO } from '@interfaces/user/user';

import { EUserRoles } from '@enums/common';

import { USER_PROFILE_AS_PO } from '@constants/queryKeys';

interface IUseQueryGetProfileAsPoReturned {
	userProfile?: IUserProfilePO;
	isLoadingUserProfile: boolean;
}

export const useQueryGetProfileAsPo = ({ id }: Partial<IId>): IUseQueryGetProfileAsPoReturned => {
	const {
		accessPermission: {
			platformOwnerAdministrator,
		},
	} = useAppSelector(auth);

	const {
		data,
		isInitialLoading,
	} = useQuery<IUserProfilePO>({
		queryKey: [USER_PROFILE_AS_PO, { id }],
		queryFn: extractQueryParams(getProfileUserAsPo),
		enabled: [!!id, platformOwnerAdministrator],
		select: (data: IUserProfilePO) => ({
			...data,
			organizations: hideDefaultRole(data.organizations),
		}),
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
		refetchOnWindowFocus: false,
	});

	return {
		userProfile: data,
		isLoadingUserProfile: isInitialLoading,
	};
};
